@use "Styles/mixins";

:host {
    display: inline-block;
    box-sizing: border-box;
    flex-shrink: 0;
    width: 63px;
    height: 63px;
}

*,
*::before,
*::after {
    box-sizing: inherit;
}

.vm-video-comment-attachment-link {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    background: mixins.get-color(background, bg-gray-150);
    color: mixins.get-color(foreground, fg-tertiary);
    text-decoration: none;
}
